// extracted by mini-css-extract-plugin
export default {"workWrapper":"home_workWrapper__Vjq-0","navBar":"home_navBar__bQbtw","keyboardAlert":"home_keyboardAlert__QQua8","prev":"home_prev__BQRxM","next":"home_next__dIrBd"};